import { LeafTabSection } from "./tab-section.component.js";
customElements.define("leaf-tab-section", LeafTabSection);
export {
  LeafTabSection
};
//# sourceMappingURL=tab-section.js.map
